module.exports = __webpack_public_path__ + "static/media/event-sample-1.434e4b48.jpeg";